import { useTranslation } from "react-i18next";
import classNames from "classnames";
import classes from "~/features/productDetails/components/ProductSummary/InfoProductMessagePMA.module.less";
import { Alert } from "~/common/mui/Alert/Alert";

interface InfoProductMessagePMAProps {
  short?: boolean;
  onClick?: () => void;
  className?: string;
}

export const InfoProductMessagePMA = ({ short, onClick, className }: InfoProductMessagePMAProps) => {
  const { t } = useTranslation();
  const cls = classNames(className, classes.message, onClick && classes.link, short && classes.short);
  return (
    <Alert severity={"info"} onClick={onClick} className={cls}>
      {t(`product.pma.messages.${short ? "short" : "long"}`)}
    </Alert>
  );
};
